
























































































































































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'

@Component({
    components: {
        Tooltip,
    },
    filters: {},
})
export default class EVMMetadata extends Vue {
    @Prop() block!: any

    get date(): Date {
        return new Date(this.block.timestamp)
    }
}
